import React from 'react';
import Banner from './section/Banner';

const ChargeLookup = () => {
  return (
    <div className='ChargeLookup__Page__Wrapper'>
      <Banner />
    </div>
  );
};

export default ChargeLookup;
